import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';
import { stripDocumentSeparators } from '@/shared/format/internal';

import { OPERATOR_STATUS_OPTIONS } from './bank-account-tabs.filters';

// Filtros da aba Transferências (P01). Leve: entra no `validateSearch` da rota do detalhe.
//
// O fio usa `searchString` e `f_status`, como Operadores e Favorecidos, e as abas dividem a URL do detalhe:
// aqui a chave da URL é própria da aba (`ted_*`) e o `param` devolve o nome do fio.

/**
 * `f_transferDate` da TED e do Pix (U50, revisão da U4a): o `DatePickerFormField` grava `toIsoStringWithTimezone(dia)`
 * (`DatePickerFormField.tsx:116-120`, `DateFormat.ts:218-232`), a meia-noite do dia com `-03:00` fixo; o filtro de tipo
 * `date` o volta a `Date` (`filterContext.tsx:144`, pelo `addFilter`, `:244`) e a URL leva `toISOString()`
 * (`filterContext.tsx:133`): `AAAA-MM-DDT03:00:00.000Z`. É o mesmo caminho do `f_paymentDate` de Pagamentos.
 */
export const transferDateFilterParam = (day: string) => new Date(`${day}T00:00:00.000-03:00`).toISOString();

/**
 * `availableFilters` da aba (`TableTransferContainer.tsx:236-246`), na ordem do "Filtrar por". O Status tem as
 * 8 opções de `statusBankAccountOptions` (`constants.ts:12-21`). O CPF/CNPJ vai sem separadores e com as letras
 * do CNPJ alfanumérico (⚠️: o legado só limpava o campo, `cleanDocumentValue`, `BankAccountFilters.tsx:63`).
 */
export const transferListFilters = defineFilters([
  { key: 'ted_searchString', param: 'searchString', type: 'search', label: msg`Todos`, placeholder: msg`Filtrar por todos` },
  { key: 'ted_transferDate', param: 'f_transferDate', type: 'date', label: msg`Data da ocorrência`, placeholder: msg`Filtrar por data da ocorrência`, toParam: transferDateFilterParam },
  { key: 'ted_beneficiaryName', param: 'f_beneficiaryName', type: 'text', label: msg`Favorecido`, placeholder: msg`Filtrar por favorecido` },
  {
    key: 'ted_beneficiaryRegistrationNumber',
    param: 'f_beneficiaryRegistrationNumber',
    type: 'document',
    label: msg`CPF/CNPJ`,
    placeholder: msg`Filtrar por CPF/CNPJ`,
    // Igual ao corpo da nova TED (`createTransferBody`): sem separadores e em maiúsculas.
    toParam: (raw: string) => stripDocumentSeparators(raw).toUpperCase(),
  },
  { key: 'ted_status', param: 'f_status', type: 'select', label: msg`Status`, options: OPERATOR_STATUS_OPTIONS },
]);
